<template>
  <div class="single-custom-page">
    <ba-header activeModule="Custom Pages"></ba-header>
    <div class="u-p4 main-content" v-loading="!current">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ name: 'dashboard' }">{{companyNameById(companyId)}}</el-breadcrumb-item>
        <el-breadcrumb-item :to="{name :'custom-pages'}">Custom Pages</el-breadcrumb-item>
        <el-breadcrumb-item v-if="current">{{ current.slug }}</el-breadcrumb-item>
      </el-breadcrumb>
      <h2 class="c-heading__page u-mt4 u-pt2">Custom Page Details</h2>
      <el-button @click="save" type="primary">Save</el-button>
      <el-button @click="$router.back()" type="info">Cancel</el-button>
      <div class="u-mt4" v-if="current">
        <div>
          <a v-if="current" :href="current.preview_link" target="_blank">{{current.preview_link}}</a>
        </div>
        <el-form class="u-mt3" ref="form" :rules="rules" :model="current">

          <el-form-item class="u-mb2" label="Page Title:">
            <el-input class="u-mt2" v-model="current.title"></el-input>
          </el-form-item>
          <el-form-item prop="checkSlug" class="u-mb0">
            <slot name="label">
              <label>
                Page Identifier:
                <el-popover placement="top-start" trigger="hover">
                  <icon class="content-help__icon" slot="reference" scale="1" :name="'question-circle'"></icon>
                  <div>This is a unique part of url for the page that will show in the navigation bar of the browser.</div>
                </el-popover>
              </label>
            </slot>

            <el-input v-model="current.slug"></el-input>

          </el-form-item>
          <div class="block u-mt3">
            <el-form-item class="u-mb0">
              <slot name="label">
                <label>
                  Page Display Order:
                  <el-popover width="600" placement="top-start" trigger="hover">
                    <icon class="content-help__icon" slot="reference" scale="1" :name="'question-circle'"></icon>
                    <div>
                      <div>This number determines the order that the page will display in the navigation menu.</div>
                      <div class="u-mt2">The higher the value the higher up in the menu this page will display.</div>
                    </div>
                  </el-popover>
                </label>
              </slot>
            </el-form-item>
            <el-form-item :label="`Order:`" class="u-mb0">
              <el-slider
                 class="u-mt2"
                 v-model="current.order"
                 width="300px">
              </el-slider>
            </el-form-item>
          </div>
          <el-form-item class="u-mb0 u-mt0">
            <slot name="label">
              <label>
                Page Type:
                <el-popover width="400" placement="top-start" trigger="hover">
                  <icon class="content-help__icon" slot="reference" scale="1" :name="'question-circle'"></icon>
                  <div>
                    <div>If Draft the custom page will not appear to the user.</div>
                    <div class="u-mt2">If Published, the custom page will appear to the user.</div>
                  </div>
                </el-popover>
              </label>
            </slot>
          </el-form-item>
          <el-switch
              class="u-mb3"
              v-model="isPublished"
              active-text="Published"
              inactive-text="Draft">
          </el-switch>
          <div class="u-mt3">
            <div class="u-text--sm u-text--light">
              <span class="u-text--capitalize">Page availability</span>
              <el-popover width="605" placement="top-start" trigger="hover">
                <icon class="content-help__icon" slot="reference" scale="1" :name="'question-circle'"></icon>
                <div>
                  <div>If Enrolled Users is selected, the custom page will only display in the left navigation of the policyholder portal.</div>
                  <div class="u-mt2">If Public Users is selected, the custom page will display on the log in and sign up screens as well as in the left navigation of the policyholder portal.</div>
                </div>
              </el-popover>
            </div>
            <el-switch
                class="u-mt3"
                v-model="current.is_public"
                active-text="Public Users"
                inactive-text="Enrolled Users">
            </el-switch>
          </div>

<!--          <div class="u-mt4">-->
<!--            <div class="u-text&#45;&#45;sm u-text&#45;&#45;light">Should this page stand out as separate link on navbar</div>-->
<!--            <el-switch-->
<!--                class="u-tm3"-->
<!--                v-model="current.has_standalone_link"-->
<!--                active-text="Shown as standalone link"-->
<!--                inactive-text="Page accessible via submenu">-->
<!--            </el-switch>-->
<!--          </div>-->
          <el-form-item label="Html content:" class="u-mt4 u-mb2 ">
            <ba-ace-editor height="500px" lang="html" theme="clouds" :content="current.html_content" @editor-update="editorChange"></ba-ace-editor>
          </el-form-item>
        </el-form>
        <el-button type="primary" @click="save">Save</el-button>

      </div>
    </div>
  </div>

</template>


<script>
import axios from 'axios'
import config from '@/config'
import { mapGetters } from 'vuex'

export default {
  components: {
    'ba-ace-editor': () => import(/* webpackChunkName: "ace" */ '../../components/ace-editor.component.vue')
  },
  name: 'ba-custom-page-details',
  data () {
    let slugRegexp = /^[a-z](-?[a-z])*$/
    var slugValidation = (rule, value, callback) => {
      let newValue = this.current.slug
      if (newValue === '') {
        callback(new Error('Page Identifier cannot be empty'))
      } else {
        if (!slugRegexp.test(newValue)) {
          callback(new Error('Page Identifier can only include lowercase letters and hyphens, for example: my-awesome-page-2021'))
          return
        } else {
          this.$refs.form.validateField('slug')
        }
        callback()
      }
    }
    return {
      companyId: this.$route.params.companyId,
      pageId: this.$route.params.pageId,
      initial: null,
      current: null,
      rules: {
        checkSlug: [
          { validator: slugValidation, trigger: 'blur' }
        ],
      }
    }
  },
  async beforeMount () {
    this.loading = true

    try {
      await this.loadInitial()
    } finally {
      this.loading = false
    }
  },
  methods: {
    editorChange (newHtmlValue) {
      this.current.html_content = newHtmlValue
    },
    detailsUrl: function () {
      return `${config.url}/v2/custom-pages/${this.pageId}/`
    },
    async save () {
      let isValid = this.$refs.form.validate()
      if (!isValid) {
        this.$notify({
          message: 'The form has errors. Correct them and retry.',
          type: 'warning'
        })
      }
      try {
        this.loading = true
        await axios.put(this.detailsUrl(), this.current)
        this.$notify({
          message: 'Page saved successfully.',
          type: 'success'
        })
        this.$router.back()
      } catch (e) {
        this.$notify({
          message: 'Error occurred while trying to save custom page. Try again, maybe the issue will go away',
          type: 'error'
        })
      } finally {
        this.loading = false
      }
    },
    async loadInitial () {
      let response = await axios.get(this.detailsUrl())
      // ace-editor cannot be bound to untracked null value. Put empty string as default.
      if (response.data.html_content === null) {
        response.data.html_content = ''
      }
      this.initial = response.data

      // copy object
      this.current = Object.assign({}, response.data)
    },

  },
  computed: {
    ...mapGetters('shared', ['companyNameById']),
    isPublished: {
      get: function () {
        return !this.current.is_draft
      },
      set: function (newVal) {
        this.current.is_draft = !newVal
      }
    }
  }
}
</script>

<style lang="scss">

  @import '../../styles/variables';
  .custom-page__html-content textarea{
    height: 900px !important;
  }
  .ace_content {
    background: #eeeeee !important;
  }

  .content-help__icon {
    border-radius: 4px;
    position: relative;
    top: 0.4em;
    color: #455b5f;
    margin: 0 0 3px 10px;
  }

</style>

